import { Injectable } from '@angular/core';
import { Utils, TunnelService } from '@mitel/cloudlink-sdk';
import { Site, Account } from '@mitel/cloudlink-sdk';
import { GatewayProgressService } from './gateway-progress.service';
import { AuthService } from './auth.service';
import { gatewayConnectStateMessages, pbxTypes, pbxConnectError, pbxStatus, commonErrorMessages, pbxMessages } from '../constants/constants';
import { ClHeaderComponent } from '@mitel/cloudlink-console-components';

@Injectable({
    providedIn: 'root'
})

export class GatewayEchoService {

  constructor(
        private progressSvc: GatewayProgressService,
        private tunnelSvc: TunnelService,
        private authSvc: AuthService,
        private clHeader: ClHeaderComponent
  ) {
    //this.interceptor.requestInProgress.subscribe((status) => this.isRequestInProgress = status)
  }


  async getGatewayConnectionAccountTagsParameters(account: Account, site: Site, accountTags: any, assumeTokenHeader: any, shouldGetData: boolean, pbxlink: any) {
    let tagParams = {};
    let pbxConnected = true;
    let statusMsg = '';

    // Check cloudlinkStatus
    if (shouldGetData == true && pbxlink != undefined) {
      let cloudlinkStatus: any;
      try {
        cloudlinkStatus = await this.tunnelSvc.getCloudlinkStatus({accountId: account.accountId, siteId: site.siteId, options: assumeTokenHeader});
      } catch (err) {
        console.warn('get cloudlinkStatus failed', err);
        //CODE_WARNING: should pbxConnected be true or false in this case?
      }

      if (cloudlinkStatus) {
        if (!cloudlinkStatus.cstaproxy) {
          //CODE_WARNING: should pbxConnected be true or false in this case?
          //Since we are setting a statusMsg, seems like it needs to be false - otherwise statusMsg is ignored
          statusMsg = gatewayConnectStateMessages.LOST_CSTA_CONNECTION;
        } else if (cloudlinkStatus.pbx_links === 'down') {
          pbxConnected = false;
          statusMsg = gatewayConnectStateMessages.LOST_OAI_CONNECTION;
        } else if (pbxlink && pbxlink['connect_error'] && pbxlink['connect_error'] !== '') {
          pbxConnected = false;
          statusMsg = this.getStatusMessageFromConnectError(pbxlink['connect_error']);
        } else if (cloudlinkStatus.pbx_links === 'init') {
          pbxConnected = false;
          statusMsg = gatewayConnectStateMessages.NOT_START_PBX_CONNECTION;
        } else if (pbxlink && pbxlink.type === pbxTypes.MIVO250) {
          // Only check registration status if pbxType is mivo250
          if (cloudlinkStatus.freeswitch_registrations === 0 || !cloudlinkStatus.cloudgateway) {
            pbxConnected = false;
            if (cloudlinkStatus.freeswitch_registrations === 0) {
              if (!cloudlinkStatus.cloudgateway) {
                statusMsg = gatewayConnectStateMessages.FAILED_REGISTER_PBX_MEDIA;
              } else {
                statusMsg = gatewayConnectStateMessages.FAILED_REGISTER_PBX;
              }
            } else {
              statusMsg = gatewayConnectStateMessages.FAILED_REGISTER_MEDIA;
            }
          }
        } else { // Check the other pbx types ignoring freeswitch_registrations, check cloudgateway
          if (!cloudlinkStatus.cloudgateway) {
            //CODE_WARNING: should pbxConnected be true or false in this case?
            //Since we are setting a statusMsg, seems like it needs to be false - otherwise statusMsg is ignored
            statusMsg = gatewayConnectStateMessages.FAILED_REGISTER_MEDIA;
          }
        }
      }
      //CODE_WARNING: If there's no cloudlinkStatus, should pbxConnected be false?
      if (pbxConnected) {
        tagParams = { connected: true, pbxConnected: pbxConnected };
      } else {
        tagParams = { connected: true, pbxConnected: pbxConnected, reason: statusMsg };
      }
    } else {
      tagParams = { connected: true };
    }
    return tagParams;
  }


  getStatusMessageFromConnectError(connectErr: string): string {
    let statusMsg = '';
    switch (connectErr) {
      case pbxConnectError.INVALID_TRUSTED_APP_PASSWORD:
        statusMsg = gatewayConnectStateMessages.INVALID_TRUSTED_APP_PASSWORD;
        break;
      case pbxConnectError.INVALID_IP:
        statusMsg = gatewayConnectStateMessages.INVALID_IP;
        break;
      case pbxConnectError.INVALID_GATEWAY_IP:
        statusMsg = gatewayConnectStateMessages.INVALID_GATEWAY_IP;
        break;
      case pbxConnectError.INVALID_PBX_IP:
        statusMsg = gatewayConnectStateMessages.INVALID_PBX_IP;
        break;
      case pbxConnectError.TRUSTED_APP_DISABLED:
        statusMsg = gatewayConnectStateMessages.TRUSTED_APP_DISABLED;
        break;
      case pbxConnectError.INVALID_TRUNK_GROUP:
        statusMsg = gatewayConnectStateMessages.INVALID_TRUNK_GROUP;
        break;
      default:
        statusMsg = gatewayConnectStateMessages.NOT_START_PBX_CONNECTION;
        break;
    }

    return statusMsg;
  }
  
  public getPbxlinks(accountId: string, siteId: string, options?: any): Promise<any> {
    return this.tunnelSvc.getPbxlinks({ accountId, siteId, options });
  }

  async getPbxStatusAccountTagsParameters(account: Account, site: Site, accountTags: any, lowLevelFlag: boolean, assumeTokenHeader: any) {
    const tagParams = {};
    let shouldGetData = false;
    let myPbxLink;

    // Get pbx data, check connection to pbx
    if (this.shouldGetPbxData(accountTags)) {
      shouldGetData = true;
      try {      
        const response = await this.getPbxlinks(account.accountId, site.siteId, assumeTokenHeader);
        if (response) {
          const pbxs = Utils.getItemsFromCollection(response);
          if (pbxs[0]) {
            myPbxLink = pbxs[0];
          }
        }
        // CODE_WARNING: I don't know why we would set this to UP even if there is no pbxLink returned
        // Leaving it like it is for now, since no known issues and taken from GWP
        tagParams['status'] = pbxStatus.UP;
      } catch (error) {
        tagParams['status'] = pbxStatus.DOWN;
        if (error.status === 503) {
          tagParams['reason'] = pbxMessages.CANNOT_CONNECT_PBX;
        } else if (error.status === 504) {
          tagParams['reason'] = pbxMessages.SYSTEM_DATA_TIMEOUT;
        } else if (typeof error === 'string') {
          console.error('failed to get PBX links', error);
          tagParams['reason'] = (error && error !== '') ? error : 'common.unknown';
        } else if (error && error.body) {
          console.error('failed to get PBX links', JSON.stringify(error));
          tagParams['reason'] = (error.body.name && error.body.name !== '') ?
                                ('getPbxlinks.' + error.body.name) : 'common.unknown';
        } else if (error instanceof Error) {
          console.error('failed to get PBX links', error.message);

          // This Auth_Error is for missing token which should be checked in all cases. In the case of incorrect 
          // 401 response from tunnel API, token is provided so this message is not returned. That way it won't   
          // fall under this check.
          if (error.message === commonErrorMessages.AUTH_ERROR) {
            if(lowLevelFlag){
              this.clHeader.logoutUser();
              //this.spinnerSvc.hide();
              return;
            } else {
              tagParams['status'] = pbxStatus.UNKNOWN;
            }
          } else if (error.message === commonErrorMessages.TYPE_ERROR) {
            tagParams['reason'] = pbxMessages.ERR_GET_PBX;
          } else {
            tagParams['reason'] = (error.message && error.message !== '' ?
                                                 error.message : 'common.unknown');
          }
        }
        //CODE_WARNING: We should probably have a default else block here
        //Will maybe add later. Not in GWP now. No known issues.
        //Unless we are ok with the status being down and no reason in tags
      }
    } else {
      tagParams['status'] = pbxStatus.UNKNOWN;
    }

    return {tagParams: tagParams, shouldGetData: shouldGetData, pbxlink: myPbxLink};
  }


  shouldGetPbxData(accountTags: any) {
    if (accountTags && accountTags['on-board-progress']) {
      const lastStepIdx = this.progressSvc.getProgressIdx(accountTags['on-board-progress']['name']);
      if (lastStepIdx >= 3) { // get the pbxLinkinfo
        return true;
      }
    }
    return false;
  }

}